import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TsPaginatorComponent } from './ts-paginator.component';
import { TsButtonModule } from '../ts-button/ts-button.module';
import { TSIconModule } from '../ts-icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [TsPaginatorComponent],
  imports: [
    CommonModule,
    TsButtonModule,
    TSIconModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  exports: [TsPaginatorComponent],
})
export class TsPaginatorModule {}
